import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 获取用户信息
  async getUserInfo() {
    return request({
      method: GET,
      url: '/member/member/user',
    })
  },

  // 获取用户的审批进度
  async getApprovalProgress() {
    return request({
      method: GET,
      url: '/member/member/getApprovalProgress',
    })
  },

  // 登陆
  async login(params) {
    return request({
      method: POST,
      url: '/member/member/login',
      params: {
        ...params,
      },
    })
  },

  // 退出登录
  async logout() {
    return request({
      method: GET,
      url: '/member/member/logout',
    })
  },

  // 邮箱发送验证码 发送类型 0 注册 1 重置
  async sendEmailVerification(params) {
    return request({
      method: POST,
      url: '/member/member/register/send/mail',
      params: {
        ...params,
      },
    })
  },

  // 邮箱验证码校验
  async checkEmail(params) {
    return request({
      method: POST,
      url: '/member/member/check/email',
      params: {
        ...params,
      },
    })
  },

  // 手机号发送验证码 发送类型 0 注册 1 重置
  async sendPhoneVerification(params) {
    return request({
      method: POST,
      url: '/member/member/register/send/phone',
      params: {
        ...params,
      },
    })
  },

  // 邮箱注册
  async emailRegister(params) {
    return request({
      method: POST,
      url: '/member/member/register/email',
      params: {
        ...params,
      },
    })
  },

  // 邮箱重置
  async emailReset(params) {
    return request({
      method: POST,
      url: '/member/member/reset/password/email',
      params: {
        ...params,
      },
    })
  },

  // 手机注册
  async phoneRegister(params) {
    return request({
      method: POST,
      url: '/member/member/register/phone',
      params: {
        ...params,
      },
    })
  },

  // 手机重置
  async phoneReset(params) {
    return request({
      method: POST,
      url: '/member/member/reset/password/phone',
      params: {
        ...params,
      },
    })
  },

  // 注册信息填报
  async registerInfoReport(params) {
    return request({
      method: POST,
      url: '/member/member/register/info',
      params: {
        ...params,
      },
    })
  },

  // 欠费通知
  async getArrearsNotice(params) {
    return request({
      method: GET,
      url: '/member/payment/web/login/arrears',
    })
  },

  // 缴费通知
  async getPaymentnotice(params) {
    return request({
      method: GET,
      url: '/member/payment/web/login/payment',
    })
  },

  // 换证通知
  async getChangeCertnotice(params) {
    return request({
      method: GET,
      url: '/member/payment/web/login/changeCert',
    })
  },

  // 换手机号
  async changePhone(params) {
    return request({
      method: POST,
      url: '/member/member/register/update/phone',
      params,
    })
  },
}
